import { render, staticRenderFns } from "./ChangeCustomerData.vue?vue&type=template&id=079f87ce&scoped=true&lang=pug"
import script from "./ChangeCustomerData.vue?vue&type=script&lang=js"
export * from "./ChangeCustomerData.vue?vue&type=script&lang=js"
import style0 from "./ChangeCustomerData.vue?vue&type=style&index=0&id=079f87ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079f87ce",
  null
  
)

export default component.exports